import React from 'react'
import { Link } from 'gatsby'
import Img from 'gatsby-image'
import IconStar from '../icons/star.svg'
import IconUser from '../icons/user.svg'
import kebabCase from '../utils/kebabCase'

export default props => (
	<>
		{props.data.allMarkdownRemark.edges.map(({ node }) => (
			<article
				className={`post-wrap visible animate fade-in d-flex ${
					node.frontmatter.thumbnail !== `` ? `` : `no-image`
				}`}
				key={node.fields.slug}
			>
				{node.frontmatter.thumbnail && (
					<Link
						to={node.fields.slug}
						className="featured-image-wrap"
						aria-label="Featured image"
					>
						<div
							className="featured-image"
							style={{
								backgroundImage: `url(${node.frontmatter.thumbnail.childImageSharp.fluid.src})`,
							}}
						/>
					</Link>
				)}
				<div className="post-info">
					{node.frontmatter.featured && (
						<span className="featured-label">
							<IconStar />
							featured
						</span>
					)}
					{/* temp category */}
					{node.frontmatter.tags && (
						<Link
							className="tag d-inline-flex"
							to={`/tags/${kebabCase(node.frontmatter.tags[0])}`}
						>
							{node.frontmatter.tags[0]}
						</Link>
					)}
					{/* temp category */}
					<span className="reading-time">{node.timeToRead} min read</span>
					<span className="date">{node.frontmatter.date}</span>
					<h2 className="title">
						<Link to={node.fields.slug}>{node.frontmatter.title}</Link>
					</h2>
					<div className="author d-flex flex-row align-items-center">
						<Link to={node.fields.slug}>
							{props.data.avatar ? (
								<Img
									fixed={props.data.avatar.childImageSharp.fixed}
									alt="avatar"
									className="avatar"
								/>
							) : (
								<div className="avatar no-image">
									<IconUser />
								</div>
							)}
						</Link>
						<div className="author-inner">
							<span className="name">
								<Link to={node.fields.slug}>{`Imed Adel`}</Link>
							</span>
						</div>
					</div>
				</div>
			</article>
		))}
	</>
)
